import { RefObject } from 'react';
import { useNavigate } from 'react-router-dom';

import { Stack, styled } from '@mui/material';

import { ThreadDto } from '@/api/generated';
import ThreadsVirtualize from '@/components/AskMeAnything/components/threads/ThreadsVirtualize';
import useChatLogic from '@/components/AskMeAnything/hooks/useChatLogic';
import RoutesMap, { generatePath } from '@/enums/RoutesMap';
import useThreads from '@/hooks/askMeAnything/useThreads';
import { useSidebarActions } from '@/store/sidebarStore';
import { useIsSmallScreen } from '@/utils/mediaUtil';

const Container = styled(Stack)({
  width: '100%',
  height: '100%'
});

interface SidebarThreadsProps {
  scrollRef: RefObject<HTMLDivElement>;
}

const SidebarThreads = ({ scrollRef }: SidebarThreadsProps) => {
  const { flatThreads } = useThreads();
  const { hideSidebar } = useSidebarActions();
  const { setChatTitle } = useChatLogic();
  const navigate = useNavigate();
  const isSmallScreen = useIsSmallScreen();
  const handleThreadClick = (thread: ThreadDto) => {
    if (!thread.id) return;
    if (isSmallScreen) {
      hideSidebar();
    }
    navigate(generatePath(RoutesMap.Chat, { threadId: thread.id }));
  };

  return (
    <Container>
      <ThreadsVirtualize
        parentRef={scrollRef}
        threads={flatThreads}
        setChatTitle={setChatTitle}
        handleThreadChange={handleThreadClick}
      />
    </Container>
  );
};

export default SidebarThreads;
